export const modalActions = {
  OPEN: "OPEN",
  CLOSE: "CLOSE",
  PUSH: "PUSH",
  POP: "POP"
};
